import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import type { NextDue } from "@/hooks/use-follow-ups";

const WEEKDAYS = ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"];

function describeNextDue(next: NextDue): string {
  const [y, m, d] = next.date.split("-").map(Number);
  const weekday = WEEKDAYS[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
  const noun = next.count === 1 ? "oppfølging" : "oppfølginger";
  return `Neste forfall: ${weekday} ${String(d).padStart(2, "0")}.${String(m).padStart(2, "0")} · ${next.count} ${noun}`;
}

interface QueueEmptyStateProps {
  nextDue?: NextDue | null | undefined;
  onNewFollowUp?: () => void;
  /** Møtebooker: poolen er tom (ingen oppfølginger å vise), med henvisning til DL. */
  variant?: "radgiver" | "motebooker";
}

/** Tom kø: «Ferdig for nå» med neste forfall og veien videre. */
export default function QueueEmptyState({ nextDue, onNewFollowUp, variant = "radgiver" }: QueueEmptyStateProps) {
  if (variant === "motebooker") {
    return (
      <div className="border-[1.5px] border-foreground bg-card p-10 text-center">
        <h2 className="font-display text-3xl font-semibold">Poolen er tom</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Det er ingen leads å ringe akkurat nå. Spør DL om en ny liste, eller kom tilbake senere.
        </p>
      </div>
    );
  }
  return (
    <div className="border-[1.5px] border-foreground bg-card p-10 text-center">
      <h2 className="font-display text-3xl font-semibold">Ferdig for nå</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        {nextDue ? describeNextDue(nextDue) : "Ingen flere oppfølginger er planlagt. Se hvordan pipen ser ut, eller lag en ny oppfølging."}
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Button asChild>
          <Link to="/salgsmuligheter/pipe">Gå til Pipe</Link>
        </Button>
        <Button variant="outline" onClick={onNewFollowUp}>
          Ny oppfølging
        </Button>
      </div>
    </div>
  );
}
